<template>
  <FlexRow :space="0" wrap style="gap: 6px">
    <Chip
      v-for="item in items"
      :key="item.name"
      :outlined="!selectedValue(item.name)"
      size="normal"
      color="primary"
      class="chip"
      no-bold
      @click="handleInput(item.name)"
      >
      {{ item.name }}
    </Chip>
    
  </FlexRow>
</template>

<script>
import FlexRow from "../atoms/FlexRow.vue";
import Chip from '../atoms/Chip'

export default {
  /**
   * このTabCloudFieldの動作が少し特殊だったので、限定的なcomponent名にしています
   * （ホントは共通化コンポーネントを下位に作るべき）
   */
  name: 'AttractiveSkillField',
  components: { Chip, FlexRow},
  props: {
    value: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    }
  },
  methods: {
    selectedValue(itemValue) {
      return Boolean(this.value && this.value.includes(itemValue))
    },
    handleInput(itemName) {
      const selectedItem = this.items.find(skill => skill.name === itemName)
      const selectedSkill = selectedItem.name
    
      const valueExisting = this.value.includes(selectedSkill)
      const result = valueExisting
        ? this.value.filter((skill) => skill !== selectedSkill)
        : [...this.value, selectedSkill]
      this.$emit('input', result)
    },
  }
}
</script>
